import _defineProperty from "/vercel/workpath0/.yarn/cache/@babel-runtime-npm-7.12.5-b3edb8ee8e-423fb00793.zip/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// @ts-ignore @styled-system/prop-types does not provide type definitions
import systemPropTypes from '@styled-system/prop-types';
import { themeGet } from '@styled-system/theme-get';
import PropTypes from 'prop-types';
import * as styledSystem from 'styled-system';
import theme from './theme';
var getKey = styledSystem.get,
    compose = styledSystem.compose,
    system = styledSystem.system;
export var get = function get(key) {
  return themeGet(key, getKey(theme, key));
}; // Common props

export var COMMON = compose(styledSystem.space, styledSystem.color, styledSystem.display);
COMMON.propTypes = _objectSpread(_objectSpread({}, systemPropTypes.space), systemPropTypes.color); // Typography props

var whiteSpace = system({
  whiteSpace: {
    property: 'whiteSpace' // cssProperty: 'whiteSpace',

  }
});
export var TYPOGRAPHY = compose(styledSystem.typography, whiteSpace);
TYPOGRAPHY.propTypes = _objectSpread(_objectSpread({}, systemPropTypes.typography), {}, {
  whiteSpace: PropTypes.oneOf(['normal', 'nowrap', 'pre-wrap', 'pre', 'pre-line'])
}); // Border props

export var BORDER = compose(styledSystem.border, styledSystem.shadow);
BORDER.propTypes = _objectSpread(_objectSpread({}, systemPropTypes.border), systemPropTypes.shadow); // Layout props

export var LAYOUT = styledSystem.layout;
LAYOUT.propTypes = systemPropTypes.layout; // Position props

export var POSITION = styledSystem.position;
POSITION.propTypes = systemPropTypes.position; // Flex props

export var FLEX = styledSystem.flexbox;
FLEX.propTypes = systemPropTypes.flexbox; // Grid props

export var GRID = styledSystem.grid;
GRID.propTypes = systemPropTypes.grid;